import { ISurvey } from 'app/interfaces/ISurvey'

export class SurveyPropertiesValidationError extends Error {

  constructor() {
    super()
    this.name = 'Missing Survey Properties'
  }

  missingProperties(missingProperties: string[], survey: ISurvey) {
    this.message = `The Survey (id: ${survey.id}) is missing the following: ${missingProperties.join(', ')}.`
    return this
  }

  missingStructureElements(missingProperties: string[]) {
    this.message = `The Survey is missing the following in its structure elements: ${missingProperties.join(', ')}.`
    return this
  }

  missingSurveyDef(missingProperties: string[]) {
    this.message = `The Survey is missing the following in its definition: ${missingProperties.join(', ')}.`
    return this
  }
}
